<div>
  <div class="short-ref" *ngFor="let referenceShort of references">
    <app-reference-short [showRefTitle]="true" [reference]="referenceShort"></app-reference-short>
  </div>
</div>
